// Custom menu event that is used for event propagation in areas
// where we want to close a menu when clicking outside of it
export const createMenuInteractionEvent = () => {
    return new CustomEvent("menuInteraction", {
    bubbles: true,
    detail: {
      type: "menuInteraction",
    },
  });
};
